import { DEMO_TRIGGERS } from '@/data/pulseDemo/demoTriggers'

/** Sample triggers with pause/delete applied; `status` mirrors real automations. */
export function buildDemoTriggers({ overrides }) {
  return DEMO_TRIGGERS.filter((item) => !overrides[item.id]?.deleted).map((item) => {
    const enabled = (overrides[item.id]?.enabled ?? item.enabled) !== false
    return { ...item, objectType: 'demo', enabled, status: enabled ? 'active' : 'paused' }
  })
}
